/**
 * 홈페이지 모바일 게시판 목록 컴포넌트
 * 공지사항과 언론보도를 펼쳐진 형태로 표시합니다.
 */

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Preview from '../Preview';
import { getDatas, getNotices } from '../../Api';

// 이미지 import
import moreImg from '../../assets/more.png';

/**
 * MobileBoardList 컴포넌트
 * 모바일에서 공지사항과 언론보도를 모두 펼쳐서 표시
 */
function MobileBoardList() {
  return (
    <MobileBoardsContainer>
      <MobileBoardSection>
        <MobileHeader>
          <MobileHeaderTitle>공지사항</MobileHeaderTitle>
          <MobileHeaderMore to="/notice">
            <img src={moreImg} width="20px" alt="공지사항 더보기" />
          </MobileHeaderMore>
        </MobileHeader>
        <Preview
          address="/notice"
          getdata={getNotices}
          isPhoto={false}
        />
      </MobileBoardSection>

      <MobileBoardSection>
        <MobileHeader>
          <MobileHeaderTitle>언론보도</MobileHeaderTitle>
          <MobileHeaderMore to="/data">
            <img src={moreImg} width="20px" alt="언론보도 더보기" />
          </MobileHeaderMore>
        </MobileHeader>
        <Preview address="/data" getdata={getDatas} isPhoto={false} />
      </MobileBoardSection>
    </MobileBoardsContainer>
  );
}

export default MobileBoardList;

/* Styled Components */

const MobileBoardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const MobileBoardSection = styled.div`
  width: 100%;
  background-color: #fff;
  padding: 20px 0;
  border-top: 1px solid #f0f0f0;
`;

// 공용 모바일 헤더
const MobileHeader = styled.div`
  position: relative;
  width: 90%;
  margin: 0 auto 15px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const MobileHeaderTitle = styled.h3`
  margin: 0;
  font-family: 'Nanum Gothic Bold';
  font-weight: bold;
  color: #333333;
  font-size: 18px;

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 22px;
  }
`;

const MobileHeaderMore = styled(Link)`
  position: static;
  width: 20px;
  height: 20px;
  display: inline-block;
`;
